'use strict'
angular.module('televisionChannelManageModule', [
        'televisionManageServiceModule'
    ])
    .controller('televisionChannelManageCtrl', ['$scope', 'televisionManageService', 'modalDialog', 'trsHttpService', '$stateParams', '$q', '$state', 'trsspliceString', function($scope, televisionManageService, modalDialog, trsHttpService, $stateParams, $q, $state, trsspliceString) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: '',
                PAGECOUNT: '',
            };

            $scope.status = {
                sortMode: true,
                siteId: $stateParams.siteid,
                dragStartIndex: '',
                dragStartItem: '',
                statusItems: [{
                    name: '全部状态',
                    value: '',
                }, {
                    name: '启用',
                    value: '0'
                }, {
                    name: '停用',
                    value: '-1'
                }],
                selectedStatus: {
                    name: '全部状态',
                    value: '',
                },
                searchWord: '',
                rights: {}
            };

            $scope.data = {
                items: [],
                selectedArray: [],
            };
            getChnlRights();
        }
        //获取栏目操作权限开始
        function getChnlRights() {
            televisionManageService.getRight($stateParams.siteid, "", "tvsetsite.channel").then(function(data) {
                $scope.status.rights = data;
            });
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            getAllChannel();
        }

        /**
         * [searchWord 检索]
         * @return {[type]} [description]
         */
        $scope.searchWord = function() {
            getAllChannel();
        };

        /**
         * [getAllChannel 获取站点下所有栏目]
         * @return {[type]} [description]
         */
        function getAllChannel() {
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'queryChannelsBySiteForCloud',
                SiteId: $scope.status.siteId,
                Status: $scope.status.selectedStatus.value,
                ChnlDesc: $scope.status.searchWord
            };
            if ($scope.status.selectedStatus.value == '') delete params.Status;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.selectedArray = [];
                $scope.data.items = data.DATA;
            });
        }

        /**
         * [disabledVerify 停用栏目前校验]
         * @param  {[type]} channel [description]
         * @return {[type]}         [description]
         */
        function disabledVerify(channel) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'deleteChannelCondition',
                ChannelId: channel.CHANNELID
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.ISSUCCESS == 'true') {
                    defer.resolve();
                } else {
                    defer.reject();
                }
            });
            return defer.promise;
        }

        /**
         * [disabledChannel 停用栏目]
         * @param  {[type]} channel [description]
         * @return {[type]}         [description]
         */
        function disabledChannel(channel) {
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'deleteChannel',
                ChannelId: channel.CHANNELID
            };
            televisionManageService.inputPassword().then(function(password) {
                LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                    params.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                        .then(function(data) {
                            modalDialog.alertType("停用成功", "", "success", false);
                            $state.go($state.current.name, $stateParams, { reload: true });
                        });
                });
            });
        }

        /**
         * [deleteVerify 删除栏目前置校验]
         * @param  {[type]} station [description]
         * @return {[type]}         [description]
         */
        function deleteVerify(channel) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'checkChannelCondition',
                ChannelIds: trsspliceString.spliceString(channel, 'CHANNELID', ',')
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [deleteTvChannel 删除站点方法]
         * @param  {[type]} station [description]
         * @return {[type]}         [description]
         */
        function deleteTvChannel(channel) {
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'removeChannels',
                ChannelIds: trsspliceString.spliceString(channel, 'CHANNELID', ',')
            };
            televisionManageService.inputPassword().then(function(password) {
                LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                    params.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                        .then(function(data) {
                            modalDialog.alertType("删除成功", "", "success", false);
                            $state.go($state.current.name, $stateParams, { reload: true });
                        });
                });
            });
        }

        /**
         * [deleteChannel 删除电视栏目]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.deleteChannel = function(item) {
            deleteVerify(item ? [item] : $scope.data.selectedArray).then(function() {
                deleteTvChannel(item ? [item] : $scope.data.selectedArray);
            });
        };

        /**
         * [slideSwitch 更改开启状态]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.slideSwitch = function(item) {
            if (item.STATUS == '0') {
                disabledVerify(item).then(function() {
                    disabledChannel(item);
                });
            } else {
                EnabledTvChannel(item);
            }
        };

        /**
         * [EnabledTvChannel 开启栏目]
         * @param {[type]} item [description]
         */
        function EnabledTvChannel(item) {
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'restoreChannels',
                ObjectIds: item.CHANNELID,
                SiteId: $scope.status.siteId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('启用成功', '', 'success', false, function() {});
                $state.go($state.current.name, $stateParams, { reload: true });
            });
        }

        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [selectAll 全选]
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.selectedArray.length == $scope.data.items.length) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [];
                for (var i in $scope.data.items) {
                    $scope.data.selectedArray.push($scope.data.items[i]);
                }
            }
        };

        /**
         * [modify 修改栏目信息]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.modify = function(item) {
            televisionManageService.createChannel({
                isNew: false,
                data: item,
            }).then(function(success) {
                getAllChannel();
            });
        };

        /**
         * [queryByDropdown 下拉列表数据切换]
         * @return {[type]} [description]
         */
        $scope.queryByDropdown = function() {
            getAllChannel();
        };

        /**
         * [dragoverCallback description;允许拖拽]
         */
        $scope.dragoverCallback = function(event, index, external, type) {
            return true;
        };

        /**
         * [dragStart description;拖拽开始]
         */
        $scope.dragStart = function(event, item, index) {
            if (!$scope.status.rights.channel.paixu) {
                modalDialog.alertType("您没有相关站点的排序权限", "", "warning", "confirm", function() {});
                return false;
            }
            $scope.status.dragStartIndex = index;
            $scope.status.dragStartItem = item;
        };

        /**
         * [dragStdropCallbackart description;拖拽结束]
         */
        $scope.dropCallback = function(event, index, item, external, type, allowedType) {
            if ($scope.status.dragStartIndex == index) {
                return;
            }
            saveSort(index);
        };

        /**
         * [saveSort 保存排序]
         * @param  {[type]} index [description]
         * @return {[type]}       [description]
         */
        function saveSort(index) {
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'orderChannels',
                startChannelId: $scope.status.dragStartItem.CHANNELID,
                targetChannelId: $scope.status.dragStartIndex > index ? $scope.data.items[index].CHANNELID : $scope.data.items[index - 1].CHANNELID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                getAllChannel();
            });
        }

        /**
         * [switchBtn 切换排序模式]
         * @return {[type]} [description]
         */
        $scope.switchBtn = function() {
            $scope.status.sortMode = !$scope.status.sortMode;
        };

        /**
         * [createChannel 新建栏目]
         * @return {[type]} [description]
         */
        $scope.createChannel = function() {
            televisionManageService.createChannel({
                isNew: true,
            }).then(function(success) {
                getAllChannel();
            });
        };
    }]);